export interface Currency {
  code: string
  name: string
  symbol: string
  decimalDigits: number
  rounding: number
}

export const DEFAULT_GBP_CURRENCY: Currency = {
  code: 'GBP',
  name: 'British Pound Sterling',
  symbol: '£',
  decimalDigits: 0,
  rounding: 0,
}

export const getCurrencyDetailsConfirmationMessage = ({
  value,
  currency,
  frequency,
}: {
  value: string
  currency: Pick<Currency, 'symbol'>
  frequency?: string
}): string =>
  `Confirmed income as ${currency.symbol}${value} ${frequency ?? ''}`.trimEnd()

export const resolveCurrency = (currencyCode: string, source?: Currency[]): Currency =>
  source?.find(currency => currency.code === currencyCode) ?? DEFAULT_GBP_CURRENCY
